module.exports = __webpack_public_path__ + "static/img/lpbody.f413f06e.jpg";